/**
 * Flow sunrise/sunset condition creation.
 * Duplicated from Scenes for Flow independence.
 */

function calculateMinsAndHoursToMins(hours: number, mins: number): number {
	return Number(60 * hours) + mins;
}

export interface FlowSunriseSunsetConditionInput {
	type: 'sunrise' | 'sunset';
	beforeAfter: 'before' | 'after';
	hours: number;
	mins: number;
	locid: string;
}

export function createSunriseSunsetConditionFromFlow(
	input: FlowSunriseSunsetConditionInput,
): Record<string, unknown> {
	const dur = calculateMinsAndHoursToMins(input.hours ?? 0, input.mins ?? 0);
	const sign = input.beforeAfter === 'after' ? '+' : '-';
	const at = input.type === 'sunrise' ? 'rise' : 'set';
	const locid = input.locid || '';
	return {
		rr: `sun:${locid}:${at}${sign}${dur}`,
		_gui_purpose: 'condition',
	};
}
